import React from 'react'
import {} from 'prop-types'
import {graphql} from 'gatsby'
import glamorous from 'glamorous'
import RehypeReact from 'rehype-react'

import CustomComponents from './custom-components'

import Default from '../layouts/default'
import Image from '../components/image'
import {H1, P, A} from '../components/common'

const ratingMap = {
  1: '🥇',
  2: '🥈',
  3: '🥉',
}

const renderAst = new RehypeReact({
  createElement: React.createElement,
  components: CustomComponents(),
}).Compiler

const ReviewPage = ({location, data, pageContext}) => {
  const node = data.review.edges[0].node
  const {
    htmlAst,
    frontmatter: {title, author, rating, url, image},
  } = node

  return (
    <Default location={location}>
      <glamorous.Div css={{display: 'flex', flexDirection: 'row'}}>
        <Image fixed={image.childImageSharp.fixed} />
        <glamorous.Div css={{marginLeft: '2rem'}}>
          <H1>{title}</H1>
          <P>
            by {author}
            <br />
            Rating {` `}
            <glamorous.Span css={{fontSize: '1.2rem'}}>{ratingMap[rating]}</glamorous.Span>
            <br />
            <A href={url} target="_blank" rel="noopener noreferrer">
              Amazon
            </A>
          </P>
        </glamorous.Div>
      </glamorous.Div>
      {renderAst(htmlAst)}
    </Default>
  )
}

export default ReviewPage

export const pageQuery = graphql`
  query ReviewBySlug($slug: String!) {
    review: allMarkdownRemark(filter: {fields: {slug: {eq: $slug}}}) {
      edges {
        node {
          htmlAst
          ...reviewAll
        }
      }
    }
  }
`
